export const style = {
  SVG_ICON_COLOR: "fill-gray-500",
};

// 最大视频上传限制 500MB
export const MAX_VIDEO_SIZE = 500 * 1024 * 1024;

export const IMAGE_ACCEPT =
  "image/png, image/jpeg, image/jpg, image/gif, image/webp";
export const VIDEO_ACCEPT = "video/*";
export const CHARA_CARD_ACCEPT = ".json, image/png";

export const CUBE_NUM_PER_TICKET = 10;

export const AUDIO_ACCEPT =
  "audio/mpeg, audio/mp3, audio/wav, audio/ogg, audio/wave, audio/x-wav, .wav";
export const MAX_AUDIO_SIZE = 10 * 1024 * 1024;
